import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadHealthDistrict: IHealthDistrictLoadActionCreator = () => {
        return {
            type: ACTION_HEALTHDISTRICTS_LOAD
        }
    },
    LoadHealthDistrictById: IHealthDistrictLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_HEALTHDISTRICTS_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IHealthDistrictLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IHealthDistrictLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_LOAD_FAILURE,
            responseStatus
        }
    },


    SaveHealthDistrict: IHealthDistrictSaveActionCreator = (formData) => {
        return {
            type: ACTION_HEALTHDISTRICTS_SAVE,
            formData
        }
    },
    SaveSuccess: IHealthDistrictSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IHealthDistrictSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateHealthDistrict: IHealthDistrictCreateActionCreator = () => {

        return {
            type: ACTION_HEALTHDISTRICTS_CREATE
        }
    },
    CreateSuccess: IHealthDistrictCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_HEALTHDISTRICTS_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IHealthDistrictCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateHealthDistrict: IHealthDistrictValidateActionCreator = (formData) => {
        return {
            type: ACTION_HEALTHDISTRICTS_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IHealthDistrictValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IHealthDistrictValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HEALTHDISTRICTS_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IHealthDistrictClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_HEALTHDISTRICTS_CLEAR,
            propertiesToClear
        }
    },

    Filter: IHealthDistrictFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_HEALTHDISTRICTS_FILTER,
            formFilter
        }
    };



export const
    ACTION_HEALTHDISTRICTS_LOAD = "ACTION_HEALTHDISTRICTS_LOAD",
    ACTION_HEALTHDISTRICTS_LOAD_BY_ID = "ACTION_HEALTHDISTRICTS_LOAD_BY_ID",
    ACTION_HEALTHDISTRICTS_LOAD_SUCCESS = "ACTION_HEALTHDISTRICTS_LOAD_SUCCESS",
    ACTION_HEALTHDISTRICTS_LOAD_FAILURE = "ACTION_HEALTHDISTRICTS_LOAD_FAILURE",

    ACTION_HEALTHDISTRICTS_SAVE = "ACTION_HEALTHDISTRICTS_SAVE",
    ACTION_HEALTHDISTRICTS_SAVE_SUCCESS = "ACTION_HEALTHDISTRICTS_SAVE_SUCCESS",
    ACTION_HEALTHDISTRICTS_SAVE_FAILURE = "ACTION_HEALTHDISTRICTS_SAVE_FAILURE",

    ACTION_HEALTHDISTRICTS_CREATE = "ACTION_HEALTHDISTRICTS_CREATE",
    ACTION_HEALTHDISTRICTS_CREATE_SUCCESS = "ACTION_HEALTHDISTRICTS_CREATE_SUCCESS",
    ACTION_HEALTHDISTRICTS_CREATE_FAILURE = "ACTION_HEALTHDISTRICTS_CREATE_FAILURE",

    ACTION_HEALTHDISTRICTS_VALIDATE = "ACTION_HEALTHDISTRICTS_VALIDATE",
    ACTION_HEALTHDISTRICTS_VALIDATE_SUCCESS = "ACTION_HEALTHDISTRICTS_VALIDATE_SUCCESS",
    ACTION_HEALTHDISTRICTS_VALIDATE_FAILURE = "ACTION_HEALTHDISTRICTS_VALIDATE_FAILURE",

    ACTION_HEALTHDISTRICTS_CLEAR = "ACTION_HEALTHDISTRICTS_CLEAR",

    ACTION_HEALTHDISTRICTS_FILTER = "ACTION_HEALTHDISTRICTS_FILTER";

export interface IHealthDistrictLoadAction {
    type: "ACTION_HEALTHDISTRICTS_LOAD";
}

export interface IHealthDistrictLoadActionCreator {
    (): IHealthDistrictLoadAction;
}

export interface IHealthDistrictLoadSuccessAction {
    type: "ACTION_HEALTHDISTRICTS_LOAD_SUCCESS";
    formData: Dtos.HealthDistrict | Dtos.HealthDistrict[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IHealthDistrictLoadSuccessActionCreator {
    (
        formData: Dtos.HealthDistrict | Dtos.HealthDistrict[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IHealthDistrictLoadSuccessAction;
}

export interface IHealthDistrictLoadFailureAction {
    type: "ACTION_HEALTHDISTRICTS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IHealthDistrictLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHealthDistrictLoadFailureAction;
}

export interface IHealthDistrictLoadByIdAction {
    type: "ACTION_HEALTHDISTRICTS_LOAD_BY_ID";
    id: number;
}

export interface IHealthDistrictLoadByIdActionCreator {
    (id: number): IHealthDistrictLoadByIdAction;
}



export interface IHealthDistrictSaveAction {
    type: "ACTION_HEALTHDISTRICTS_SAVE";
    formData: Dtos.HealthDistrict;

}

export interface IHealthDistrictSaveActionCreator {
    (
        formData: Dtos.HealthDistrict
    ): IHealthDistrictSaveAction;
}

export interface IHealthDistrictSaveSuccessAction {
    type: "ACTION_HEALTHDISTRICTS_SAVE_SUCCESS";
    formData: Dtos.HealthDistrict;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IHealthDistrictSaveSuccessActionCreator {
    (
        formData: Dtos.HealthDistrict,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IHealthDistrictSaveSuccessAction;
}

export interface IHealthDistrictSaveFailureAction {
    type: "ACTION_HEALTHDISTRICTS_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHealthDistrictSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHealthDistrictSaveFailureAction;
}

export interface IHealthDistrictCreateAction {
    type: "ACTION_HEALTHDISTRICTS_CREATE"
}

export interface IHealthDistrictCreateActionCreator {
    (): IHealthDistrictCreateAction
}

export interface IHealthDistrictCreateSuccessAction {
    type: "ACTION_HEALTHDISTRICTS_CREATE_SUCCESS";
    formData: Dtos.HealthDistrict;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IHealthDistrictCreateSuccessActionCreator {
    (
        formData: Dtos.HealthDistrict,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IHealthDistrictCreateSuccessAction;
}

export interface IHealthDistrictCreateFailureAction {
    type: "ACTION_HEALTHDISTRICTS_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHealthDistrictCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHealthDistrictCreateFailureAction;
}

export interface IHealthDistrictValidateAction {
    type: "ACTION_HEALTHDISTRICTS_VALIDATE";
    formData: Dtos.HealthDistrict;

}

export interface IHealthDistrictValidateActionCreator {
    (
        formData: Dtos.HealthDistrict
    ): IHealthDistrictValidateAction;
}

export interface IHealthDistrictValidateSuccessAction {
    type: "ACTION_HEALTHDISTRICTS_VALIDATE_SUCCESS";
    formData: Dtos.HealthDistrict;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IHealthDistrictValidateSuccessActionCreator {
    (
        formData: Dtos.HealthDistrict,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IHealthDistrictValidateSuccessAction;
}

export interface IHealthDistrictValidateFailureAction {
    type: "ACTION_HEALTHDISTRICTS_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHealthDistrictValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHealthDistrictValidateFailureAction;
}

export interface IHealthDistrictClearAction {
    type: "ACTION_HEALTHDISTRICTS_CLEAR";
    propertiesToClear?: string[];
}

export interface IHealthDistrictClearActionCreator {
    (propertiesToClear?: string[]): IHealthDistrictClearAction;
}

export interface IHealthDistrictFilterActionCreator {
    (formFilter: IFormFilter): IHealthDistrictFilterAction;
}

export interface IHealthDistrictFilterAction {
    type: "ACTION_HEALTHDISTRICTS_FILTER";
    formFilter: IFormFilter;
}

export type HealthDistrictAction =
    IHealthDistrictLoadAction |
    IHealthDistrictLoadByIdAction |
    IHealthDistrictLoadFailureAction |
    IHealthDistrictLoadSuccessAction |
    IHealthDistrictSaveAction |
    IHealthDistrictSaveSuccessAction |
    IHealthDistrictSaveFailureAction |
    IHealthDistrictCreateAction |
    IHealthDistrictCreateSuccessAction |
    IHealthDistrictCreateFailureAction |
    IHealthDistrictValidateAction |
    IHealthDistrictValidateSuccessAction |
    IHealthDistrictValidateFailureAction |
    IHealthDistrictClearAction |
    IHealthDistrictFilterAction;
